import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IntercomProvider as Provider } from "react-use-intercom";
import { ClientOnly } from "remix-utils";
import ComponentErrorBoundary from "~/components/ErrorBoundary";
import crypto from "crypto";

export const getUserHash = (email: string) => {
  return crypto
    .createHmac("sha256", process.env.INTERCOM_SECRET || "Sup3rs3cr3t")
    .update(email)
    .digest()
    .toString("hex");
};

const INTERCOM_APPID = "pytdickr";
export const IntercomProvider: FC<{ children: ReactNode }> = (props) => {
  const { i18n } = useTranslation();

  return (
    <ClientOnly>
      {() => (
        <ComponentErrorBoundary>
          <Provider
            autoBoot={process.env.NODE_ENV === "production"}
            appId={INTERCOM_APPID}
            autoBootProps={{ languageOverride: i18n.language }}
          >
            {props.children}
          </Provider>
        </ComponentErrorBoundary>
      )}
    </ClientOnly>
  );
};
